<template>
  <div class="content">
    <!--  <div class="title">《广东名优企业品牌》提名资格填报</div>-->
    <img style="width: 100%;height: auto;display: block;" :src="require('../../assets/'+appTheme+'/img.jpg')" alt="" />
    <van-form @submit="onSubmit">
      <van-field
        v-model="name"
        name="公司名称(中文)"
        label="公司名称(中文)"
        required
        placeholder="请输入公司全称"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="en_name"
        name="公司名称(英文)"
        label="公司名称(英文)"
        required
        type="textarea"
        placeholder="请输入公司英文全称，以及外国客商"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        readonly
        clickable
        name="picker"
        required
        :value="valueCity"
        right-icon="arrow"
        label="公司注册地"
        placeholder="请选择所在地"
        @click="showPickerCity = true"
      />
      <van-popup v-model="showPickerCity" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnsCity"
          @confirm="onConfirmCity"
          @cancel="showPickerCity = false"
        />
      </van-popup>
      <!--    <van-field-->
      <!--      v-model="fieldValue"-->
      <!--      is-link-->
      <!--      readonly-->
      <!--      required-->
      <!--      label="公司注册地"-->
      <!--      placeholder="请选择所在地"-->
      <!--      @click="show = true"-->
      <!--    />-->
      <!--    <van-popup v-model="show" round position="bottom">-->
      <!--      <van-cascader-->
      <!--        v-model="cascaderValue"-->
      <!--        title="请选择所在地"-->
      <!--        :options="options"-->
      <!--        @close="show = false"-->
      <!--        @finish="onFinish"-->
      <!--      />-->
      <!--    </van-popup>-->
      <van-field
        v-model="address"
        required
        name="公司详细地址"
        label="公司详细地址"
        placeholder="请输入公司详细地址"
        :rules="[{ required: true, message: '' }]"
      />
      <div class="van-field-box" style="border-bottom: undefined solid #ccc;">
        <div style="width: 65%;display: inline-block;">
          <van-field
            v-model="ceo"
            name="董事长"
            label="董事长"
            required
            placeholder="请输入董事长名称"
            :rules="[{ required: true, message: '' }]"
          >
          </van-field>
        </div>
        <div style="width: 35%;display: inline-block;">
          <van-radio-group v-model="sex_ceo" direction="horizontal">
            <van-radio name="先生">先生</van-radio>
            <van-radio name="女士">女士</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="van-field-box" style="border-bottom: undefined solid #ccc;">
        <div style="width: 65%;display: inline-block;">
          <van-field
            v-model="founder"
            name="创始人"
            label="创始人"
            required
            placeholder="请输入创始人名称"
            :rules="[{ required: true, message: '' }]"
          >
          </van-field>
        </div>
        <div style="width: 35%;display: inline-block;">
          <van-radio-group v-model="sex_founder" direction="horizontal">
            <van-radio name="先生">先生</van-radio>
            <van-radio name="女士">女士</van-radio>
          </van-radio-group>
        </div>
      </div>
<!--      <van-field-->
<!--        v-model="major"-->
<!--        name="所属行业"-->
<!--        required-->
<!--        label="所属行业"-->
<!--        placeholder="请输入所属行业"-->
<!--        :rules="[{ required: true, message: '' }]"-->
<!--      />-->
      <van-field
        readonly
        clickable
        name="picker"
        required
        :value="valueBusiness"
        label="企业入编行业"
        placeholder="请选择入编行业"
        @click="showPicker = true"
      >
        <template #button>
          <van-button size="small" style="border: none;background: #fff;color: #282828;padding: 0" type="primary">卷(分18卷发行)</van-button>
        </template>
      </van-field>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirmBusiness"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field name="uploader" label="营业执照(盖公章)" required :rules="[{ required: true, message: '' }]">
        <template #input>
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadLicense" :beforeRead="beforeRead" :max-count="1" v-model="licenseList" />
        </template>
      </van-field>
      <div class="hint-license-box">
        <div class="hint-license">请上传企业的营业执照</div>
      </div>
      <van-field
        v-model="sale"
        name="企业年营收"
        label="企业年营收"
        placeholder="请输入企业年营收">
        <template #button>
          <van-button style="background: #ffffff;color: #282828;border: none;" size="small" type="primary">万元</van-button>
        </template>
      </van-field>
      <van-field
        v-model="productDes"
        name="企业核心产品"
        label="企业核心产品"
        type="textarea"
        rows="1"
        placeholder="请输入企业有核心竞争力的产品"
      />
      <div class="major-box">
        <div class="major-box-uploader content-center" style="align-items: self-start">
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadMajor" :before-read="beforeRead" :max-count="1" v-model="fileListMajor" />
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadMajorSec" :before-read="beforeRead" :max-count="1" v-model="fileListMajorSec" />
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadMajorFir" :before-read="beforeRead" :max-count="1" v-model="fileListMajorFir" />
        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license" style="padding-left: 0;text-align: center;">可上传核心产品照片</div>
      </div>
      <div class="brand-box left-justifying" style="align-items: self-start;">
        <div class="title-name">
          企业商标
        </div>
        <div>
          <div class="left-justifying" style="align-items: self-start;">
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadBrand" :before-read="beforeRead" :max-count="1" v-model="fileListBrand" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadBrandSec" :before-read="beforeRead" :max-count="1" v-model="fileListBrandSec" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadBrandFir" :before-read="beforeRead" :max-count="1" v-model="fileListBrandFir" />
          </div>

        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license">可上传多个企业商标</div>
      </div>
      <van-field
        v-model="site"
        name="企业网址"
        label="企业网址"
        placeholder="请输入企业的网站网址"
      />
      <van-field
        v-model="wehcat"
        name="企业微信号"
        label="企业微信号"
        placeholder="请输入企业微信号名称"
      />
      <van-field
        v-model="weibo"
        name="企业微博号"
        label="企业微博号"
        placeholder="请输入企业微博号名称"
      />
      <van-field
        v-model="wechat_video"
        name="企业视频号"
        label="企业视频号"
        placeholder="请输入企业视频号名称"
      />
      <!--    <van-field name="uploader" label="企业资质">-->
      <!--      <template #input>-->
      <!--        <van-uploader :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadQualit" :before-read="beforeRead" :max-count="3" v-model="qualityList" />-->
      <!--      </template>-->
      <!--    </van-field>-->
      <div class="brand-box left-justifying" style="align-items: self-start;">
        <div class="title-name">
          企业资质
        </div>
        <div>
          <div class="left-justifying" style="align-items: self-start;">
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadQuality" :before-read="beforeRead" :max-count="1" v-model="fileListQuality" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadQualitySec" :before-read="beforeRead" :max-count="1" v-model="fileListQualitySec" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadQualityFir" :before-read="beforeRead" :max-count="1" v-model="fileListQualityFir" />
          </div>
        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license" style="padding-left: 3.4rem;">包括但不仅限于：税务证、组织机构代码证、安全生产许可证、工业产品证或许可证、特殊许可证、其它资质</div>
      </div>
      <div class="brand-box left-justifying" style="align-items: self-start;">
        <div class="title-name">
          企业认证
        </div>
        <div>
          <div class="left-justifying" style="align-items: self-start;">
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAuth" :before-read="beforeRead" :max-count="1" v-model="authList" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAuthSec" :before-read="beforeRead" :max-count="1" v-model="authListSec" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAuthFir" :before-read="beforeRead" :max-count="1" v-model="authListFir" />
          </div>

        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license">可上传体系认证和产品认证</div>
      </div>    <div class="brand-box left-justifying" style="align-items: self-start;">
      <div class="title-name">
        产品质检报告
      </div>
      <div>
        <div class="left-justifying" style="align-items: self-start;">
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadReport" :before-read="beforeRead" :max-count="1" v-model="qualityListReport" />
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadReportSec" :before-read="beforeRead" :max-count="1" v-model="qualityListSec" />
          <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadReportFir" :before-read="beforeRead" :max-count="1" v-model="qualityListFir" />
        </div>
      </div>
    </div>
      <div class="hint-license-box">
        <div class="hint-license">可上传企业质检报告产品认证，例如：3c、欧盟等认证</div>
      </div>
      <div class="brand-box left-justifying" style="align-items: self-start;">
        <div class="title-name">
          企业荣誉
        </div>
        <div>
          <div class="left-justifying" style="align-items: self-start;">
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadHonour" :before-read="beforeRead" :max-count="1" v-model="honourList" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadHonourSec" :before-read="beforeRead" :max-count="1" v-model="honourListSec" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadHonourFir" :before-read="beforeRead" :max-count="1" v-model="honourListFir" />
          </div>
        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license">可上传企业相关的荣誉证书</div>
      </div>
      <div class="brand-box left-justifying" style="align-items: self-start;">
        <div class="title-name">
          企业获奖
        </div>
        <div>
          <div class="left-justifying" style="align-items: self-start;">
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAwards" :before-read="beforeRead" :max-count="1" v-model="awardsList" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAwardsSec" :before-read="beforeRead" :max-count="1" v-model="awardsListSec" />
            <van-uploader :preview-options="previewImage" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadAwardsFir" :before-read="beforeRead" :max-count="1" v-model="awardsListFir" />
          </div>
        </div>
      </div>
      <div class="hint-license-box">
        <div class="hint-license">可上传企业相关的获奖信息</div>
      </div>
      <!--    <van-field name="uploader" label="企业证书">-->
      <!--      <template #input>-->
      <!--        <van-uploader :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterReadCert" :before-read="beforeRead" :max-count="1" v-model="certList" />-->
      <!--      </template>-->
      <!--    </van-field>-->
      <div class="intellectual-box">
        <van-field style="margin-top: 5.33333vw;"
                   v-model="property"
                   name="企业知识产权数"
                   label="企业知识产权数" type="textarea"
                   placeholder="可输入多个企业知识产权数,以逗号(,)隔开，包括但不仅限于：高标发明、实用外型、软件著作权、外观专利、版权"
        />
      </div>
      <van-field
        v-model="shop_inside"
        name="企业国内网店链接"
        label="企业国内网店链接"
        type="textarea"
        placeholder="可输入多个企业国内网店链接,以逗号(,)隔开"
      />
      <van-field
        v-model="shop_outside"
        name="企业国外网店链接"
        label="企业国外网店链接"
        type="textarea"
        placeholder="可输入多个企业国外网店链接,以逗号(,)隔开"
      />
      <van-field
        v-model="company_vr"
        name="企业元宇宙链接(VR)"
        label="企业元宇宙链接(VR)"
        type="textarea"
        placeholder="可输入多个企业元宇宙链接(VR)"
      />
      <van-field
        v-model="product_vr"
        name="产品元宇宙链接(VR)"
        label="产品元宇宙链接(VR)"
        type="textarea"
        placeholder="可输入多个产品元宇宙链接(VR)"
      />

      <van-field
        v-model="motto"
        name="企业格言(中英文)"
        label="企业格言(中英文)"
        type="textarea"
        placeholder="请填写企业格言(中英文各100字以内)"
      />
      <van-field
        v-model="brandDes"
        name="品牌故事(中英文)"
        label="品牌故事(中英文)"
        type="textarea"
        placeholder="请填写品牌故事(中英文各500字以内)"
      />
      <van-field
        v-model="founder_story"
        name="创始人故事(中英文)"
        label="创始人故事(中英文)"
        type="textarea"
        placeholder="请填写创始人故事(中英文各500字以内)"
      />
      <van-field
        v-model="makings"
        name="生产主要原材料"
        label="生产主要原材料"
        type="textarea"
        placeholder="请输入生产主要原材料，例如：ABS塑料、铝合金..."
      />
      <van-field
        v-model="exportRegion"
        name="产品主要出口国家地区"
        type="textarea"
        label="产品主要出口国家地区"
        placeholder="可输入多个产品出口国家地区,以逗号(,)隔开"
      />
      <van-field
        v-model="buyer"
        name="产品主要买家人群"
        label="产品主要买家人群"
        placeholder="例如：老年人、宝妈"
      />
      <van-field
        v-model="people_outside"
        name="外贸业务联系人(中英文)"
        label="外贸业务联系人(中英文)"
        placeholder="请输入外贸业务联系人"
      />
      <van-field
        v-model="people_inside"
        name="国内业务联系人"
        label="国内业务联系人"
        placeholder="请输入国内业务联系人"
      />
      <van-field
        v-model="telephone"
        name="业务联系手机"
        label="业务联系手机"
        placeholder="请输入业务联系手机"
      />
      <van-field
        v-model="propagate"
        name="企业宣传片(链接)"
        label="企业宣传片(链接)"
        placeholder="请输入企业宣传片(链接)"
      />
      <van-field style="margin-top: 5.33333vw"
                 v-model="handle_things"
                 rows="5"
                 autosize
                 label="企业需编纂委员会协助解决的问题或建议"
                 type="textarea"
                 required
                 placeholder="请填写企业需编纂委员会协助解决的问题或建议"
                 :rules="[{ required: true, message: '' }]"
      />
      <div style="margin: 2.13333vw;padding: 5.33333vw 0 0">

        <van-button v-if="infoData != ''" round block type="info" native-type="submit" style="background: #FDD80D;border-color: #FDD80D;color: #282828">提交</van-button>
        <van-button v-else round block type="info" native-type="submit" style="background: #FDD80D;border-color: #FDD80D;color: #282828">提交</van-button>
      </div>
    </van-form>
    <div class="hint-box">申明：（一）入册《广东名优企业品牌》的企业，将由中国国际图书贸易公司向海外发行，同时由新华书店全国发行，按照国家相关规定向全世界所有中国 驻外大使馆、领事馆和侨商会等寄送图书，供海外客商咨询、查阅和指导交易，请务必真实填写。</div>
    <div class="hint-box" style="padding-bottom: 0;">（二）入选标准：</div>
    <div class="hint-box" style="padding-top: 1.33333vw;">1、入选企业必须是在政府合法注册的依规依法企业,其产品是经过国家批准和检验的合格产品,杜绝一切假冒、伪劣、仿制产品和三无产品。</div>
    <div class="hint-box" style="padding-top: 1.33333vw;">2、入选企业和产品,必须是没有受到国家任何行政部门处罚过的优秀企业,任何在近三年内受到县级以上人民政府及其职能部门处罚的企业和产品,不得入选。</div>
    <div class="hint-box" style="padding-top: 1.33333vw;">3、入选企业和产品，必须是获得国家地市级人民政府及其行政职能部门、市级以上行业协会、商会、消费者协会、专业产品协会、以及正式在政府注册并批准成立的社会各类评奖机构和单位，授予和评出的各类获奖产品品牌。</div>
    <div class="item-box" style="padding-top:5.33333vw;">广东省工商联（总商会）</div>
    <div class="item-box"> 广东人民出版社</div>
    <div class="item-box" style="padding-left: 2vw;">《广东名优企业品牌》编纂委员会</div>
    <div class="item-box" style="padding-bottom: 5.33333vw;">编纂组委会执行主任：何灌昌 (18688111127)</div>
    <div class="zicon-img-box">
      <img class="zicon-img" :src="require('../../assets/'+appTheme+'/zicon.png')" alt="" />
    </div>
    <img style="width: 100%;height: auto;display: block;" :src="require('../../assets/'+appTheme+'/shu.jpg')" alt="" />
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import upLoaderImg from "../../api/upLoaderImg";
import { getCompanyReport, companyEdit, companyReportPost } from '@/api/company'
import Vue from 'vue';
import { Cascader } from 'vant';

Vue.use(Cascader);
import { Dialog } from 'vant';
export default {
  name: "applyForEdit",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      previewImage:{ // 图片预览关闭按钮
        closeable: true,
      },
      codeNum:'',
      valueBusiness: '',
      columns: ['家具卷', '服装卷', '家电卷', '轻工、五金卷', '皮革卷','医疗器械化妆品卷', '陶瓷卷', '材料卷（建材）', '化工卷', '电子卷',
        '农产品卷','灯具照明卷', '珠宝卷', '饰品卷', '食品', '鞋业卷','酒店及酒店用品卷', '玩具游戏卷', '其它'],
      showPicker: false,
      areaList,
      value: '',
      showArea: false,
      sex:'',
      valueCity:'',
      showPickerCity: false,
      columnsCity:[
        { text: "中山市", value: "101"},
        { text: "广州市", value: "102" },
        { text: "珠海市", value: "103" },
        { text: "深圳市", value: "104" },
        { text: "韶关市", value: "105" },
        { text: "汕头市", value: "106" },
        { text: "佛山市", value: "107" },
        { text: "江门市", value: "108" },
        { text: "湛江市", value: "109" },
        { text: "茂名市", value: "110" },
        { text: "肇庆市", value: "110" },
        { text: "惠州市", value: "111" },
        { text: "汕尾市", value: "112" },
        { text: "河源市", value: "113" },
        { text: "清远市", value: "114" },
        { text: "东莞市", value: "115" },
        { text: "潮州市", value: "116" },
        { text: "揭阳市", value: "117" },
        { text: "云浮市", value: "118" },
        { text: "梅州市", value: "119" },
      ],
      AddressInfo: '',
      brand:[],
      intellectual:'', // 知识产权
      qualityListReport:[], // 质检报告
      qualityListSec:[], // 质检报告
      qualityListFir:[], // 质检报告
      reportImg:'',//质检报告
      reportImgSec:'',//质检报告
      reportImgThr:'',//质检报告
      fileListMajor: [], // 主要核心产品
      fileListMajorSec: [],
      fileListMajorFir: [],
      majorImg:'',// 核心产品第一张照片
      majorImgSec:'',// 核心产品第2张照片
      majorImgThr:'',// 核心产品第3张照片
      fileListBrand: [], // 商标
      fileListBrandSec: [],
      fileListBrandFir: [],
      brandImg:'',// 企业商标第一张照片
      brandImgSec:'',// 企业商标第2张照片
      brandImgThr:'',// 企业商标第3张照片
      licenseList: [], // 营业执照
      qualityList:[], //企业资质
      fileListQuality:[], //企业资质
      fileListQualitySec:[],
      fileListQualityFir:[],
      qualityImg:'',// 企业资质第一张照片
      qualityImgSec:'',// 企业资质第2张照片
      qualityImgThr:'',// 企业资质第3张照片
      authList: [], //企业认证
      authImg:'',// 企业认证第一张照片
      authImgSec:'',// 企业认证第2张照片
      authImgThr:'',// 企业认证第2张照片
      authListSec: [],
      authListFir:[],
      honourList: [], //企业荣誉
      honourListSec: [],
      honourListFir:[],
      honourImg:'',// 企业荣誉第一张照片
      honourImgSec:'',// 企业荣誉第2张照片
      honourImgThr:'',// 企业荣誉第2张照片
      certList: [], //企业证书
      uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
      fileList: [],
      name: '',
      en_name:'', //公司名称(英)
      place:'', // 公司注册地
      ceo: '', // 董事长 sex
      sex_ceo: '先生',// 1男 2女
      founder: '', // 创始人
      productDes:'', // 企业核心产品
      sex_founder: '先生', // 1男 2女
      major:'',// 所属行业
      number:'', //企业入编(行业) 卷号
      address: '', // address 总部地址
      licenseImg: '', // 营业执照
      desc:'',
      type:'',
      site:'', // 网址
      people_outside:'', // 外贸业务联系人（中英文）
      telephone: '', // 国内业务联系电话
      people_inside:'', // 业务联系人
      propagate: '', // 宣传片（链接)
      people:'',
      sale:'', //  企业年营业额
      product: {desc:'',image:[]},// 核心产品描述
      trademark: [], // 商标
      property:'', // 企业知识产权
      shop_inside: '', // 国内网店链接
      shop_outside: '', // 国外网店链接
      company_vr: '', // 企业元宇宙链接(VR)
      product_vr: '', // 产品元宇宙链接(VR)
      motto: '', // 企业格言
      brandDes: '',// 品牌故事
      founder_story: '', // 创始人故事
      wehcat:'', // 微信号
      weibo:'', // 微博号
      shop:'', // 网店
      wechat_video:'', // 视频号
      quality: [],// 资质证书图片
      product_report:[], // 产品质检报告
      auth:[], // 企业认证
      honour: [], // 企业荣誉
      merit: [], // 企业获奖
      awardsList:[],// 获奖
      awardsListSec: [],
      awardsListFir:[],
      awardsImg:'',// 企业获奖第一张照片
      awardsImgSec:'',// 企业获奖2张照片
      awardsImgThr:'',// 企业获奖第2张照片
      exportRegion:'', // 出口地区 export
      buyer:'', // buyer 买家人群
      makings:'', // 原材料
      handle_things:'',// 需协助处理事情
      show: false,
      fieldValue: '',
      cascaderValue: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: "广东省",
          value: "1",
          children: [
            {
              text: "中山市",
              value: "101",
              // children: [
              //   { text: "南山区", value: "10101" },
              //   { text: "宝安区", value: "10102" },
              //   { text: "龙华区", value: "10103" },
              //   { text: "福田区", value: "10104" },
              // ]
            },
            { text: "广州市", value: "102" },
            { text: "珠海市", value: "103" },
            { text: "深圳市", value: "104" },
            { text: "韶关市", value: "105" },
            { text: "汕头市", value: "106" },
            { text: "佛山市", value: "107" },
            { text: "江门市", value: "108" },
            { text: "湛江市", value: "109" },
            { text: "茂名市", value: "110" },
            { text: "肇庆市", value: "110" },
            { text: "惠州市", value: "111" },
            { text: "汕尾市", value: "112" },
            { text: "河源市", value: "113" },
            { text: "清远市", value: "114" },
            { text: "东莞市", value: "115" },
            { text: "潮州市", value: "116" },
            { text: "揭阳市", value: "117" },
            { text: "云浮市", value: "118" },
            { text: "梅州市", value: "119" },
          ],
        },
      ],
      infoData: ''
    };
  },
  created() {
    this.codeNum = this.$route.query.code
    this.getDesReport()
  },
  methods: {
    onConfirmCity(value){
      this.valueCity = value.text;
      this.showPickerCity = false;
      console.log(value.text)
    },
    getDesReport(){
      var data = {
        code: this.codeNum
      }
      getCompanyReport(data).then(s => {
        // console.log(res)
        var res = s.data
        // console.log(res)
        this.infoData = s.data
        if (this.infoData != ''){
          var ceos = this.infoData.ceo.split(/[\s\n]/)
          this.ceo = ceos[0]
          this.sex_ceo = ceos[1]
          var founders = res.founder.split(/[\s\n]/)
          this.founder = founders[0]
          this.sex_founder = founders[1]
          this.name = res.name
          this.en_name = res.en_name
          this.valueCity = res.place
          this.address = res.address
          // this.major= res.major // 所属行业
          this.valueBusiness = res.number 	// 企业入编(行业) 卷号
          this.licenseImg = res.license
          this.licenseList = [{url:res.license}]
          this.sale = res.sale
          this.productDes = res.product.desc // 核心产品描述
          var img_major = res.product.image // 核心产品描述
          if(img_major != null){
            if(img_major.length==1){
              this.fileListMajor= [{url:img_major[0]}] // 主要核心产品
              this.majorImg = img_major[0]// 核心产品第一张照片
            } else if (img_major.length==2){
              this.fileListMajor= [{url:img_major[0]}] // 主要核心产品
              this.majorImg = img_major[0]// 核心产品第一张照片
              this.fileListMajorSec= [{url:img_major[1]}]
              this.majorImgSec = img_major[1]// 核心产品第2张照片
            }else if (img_major.length==3){
              this.fileListMajor= [{url:img_major[0]}] // 主要核心产品
              this.majorImg = img_major[0]// 核心产品第一张照片
              this.fileListMajorSec= [{url:img_major[1]}]
              this.majorImgSec = img_major[1]// 核心产品第2张照片
              this.fileListMajorFir= [{url:img_major[2]}]
              this.majorImgThr = img_major[2]// 核心产品第3张照片
            }
          }

          console.log('dd',img_major)
          var trademarks = res.trademark
          console.log(trademarks)
          if (trademarks != null){
            if(trademarks.length==1){
              this.fileListBrand= [{url:trademarks[0]}] // 企业商标第照片
              this.brandImg = trademarks[0]// 企业商标第一张照片
            } else if (trademarks.length==2){
              this.fileListBrand= [{url:trademarks[0]}] // 企业商标第照片
              this.brandImg = trademarks[0]// 企业商标第一张照片
              this.fileListBrandSec= [{url:trademarks[1]}]
              this.brandImgSec = trademarks[1]// 企业商标第2张照片
            }else if (trademarks.length == 3){
              console.log(trademarks.length)

              this.fileListBrand= [{url:trademarks[0]}] // 企业商标第照片
              this.brandImg = trademarks[0]// 企业商标第照片

              this.fileListBrandSec= [{url:trademarks[1]}]
              this.brandImgSec = trademarks[1]// 核心产品第2张照片

              this.fileListBrandFir = [{url:trademarks[2]}]// 核心产品第3张照片
              this.brandImgThr = trademarks[2]// 核心产品第3张照片
            }
          }

          var qualityArr = res.auth //企业认证
          if(qualityArr!=null){
            if(qualityArr.length==1){
              this.fileListQuality= [{url:qualityArr[0]}] // 企业资质
              this.qualityImg = qualityArr[0]//企业资质

            } else if (qualityArr.length==2){
              this.fileListQuality= [{url:qualityArr[0]}] // 企业资质
              this.qualityImg = qualityArr[0]//企业资质

              this.fileListQualitySec= [{url:qualityArr[1]}] // 企业资质
              this.qualityImgSec = qualityArr[1]//企业资质

            }else if (qualityArr.length==3){
              this.fileListQuality= [{url:qualityArr[0]}] // 企业资质
              this.qualityImg = qualityArr[0]//企业资质

              this.fileListQualitySec= [{url:qualityArr[1]}] // 企业资质
              this.qualityImgSec = qualityArr[1]//企业资质

              this.fileListQualityFir= [{url:qualityArr[2]}] // 企业资质
              this.qualityImgThr = qualityArr[2]// 企业资质
            }
          }



          var authArr = res.auth //企业认证

          if(authArr !=null){
            if(authArr.length==1){
              this.authList= [{url:authArr[0]}] // 企业认证第一张照片
              this.authImg = authArr[0]//企业认证第一张照片

            } else if (authArr.length==2){
              this.authList= [{url:authArr[0]}] // 企业认证第一张照片
              this.authImg = authArr[0]//企业认证第一张照片

              this.authListSec= [{url:authArr[1]}] // 企业认证第一张照片
              this.authImgSec = authArr[1]//企业认证第一张照片

            }else if (authArr.length==3){
              this.authList= [{url:authArr[0]}] // 企业认证第一张照片
              this.authImg = authArr[0]//企业认证第一张照片

              this.authListSec= [{url:authArr[1]}] // 企业认证第一张照片
              this.authImgSec = authArr[1]//企业认证第一张照片

              this.authListFir= [{url:authArr[2]}] // 企业荣誉第一张照片
              this.authImgThr = authArr[2]// 企业荣誉第一张照片
            }
          }




          var honourArr = res.honour

          if(honourArr != null) {
            if(honourArr.length==1){
              this.honourList= [{url:honourArr[0]}] // 企业荣誉第一张照片
              this.honourImg = honourArr[0]// 企业荣誉第一张照片
            } else if (honourArr.length==2){
              this.honourList= [{url:honourArr[0]}] // 企业荣誉第一张照片
              this.honourImg = honourArr[0]// 企业荣誉第一张照片
              this.honourListSec= [{url:honourArr[1]}] // 企业荣誉第一张照片
              this.honourImgSec = honourArr[1]// 企业荣誉第一张照片
            }else if (honourArr.length==3){
              this.honourList= [{url:honourArr[0]}] // 企业荣誉第一张照片
              this.honourImg = honourArr[0]// 企业荣誉第一张照片
              this.honourListSec= [{url:honourArr[1]}] // 企业荣誉第一张照片
              this.honourImgSec = honourArr[1]// 企业荣誉第一张照片
              this.honourListFir= [{url:honourArr[2]}] // 企业荣誉第一张照片
              this.honourImgThr = honourArr[2]// 企业荣誉第一张照片
            }
          }
          var reportArr = res.product_report
          if(reportArr != null){
            if(reportArr.length==1){
              this.qualityListReport= [{url:reportArr[0]}] // 质检报告
              this.reportImg = reportArr[0]// 质检报告
            } else if (reportArr.length==2){
              this.qualityListReport= [{url:reportArr[0]}] // 质检报告
              this.reportImg = reportArr[0]// 质检报告

              this.qualityListSec= [{url:reportArr[1]}] // 企业荣誉第一张照片
              this.reportImgSec = reportArr[1]// 企业荣誉第一张照片

            }else if (reportArr.length==3){
              this.qualityListReport= [{url:reportArr[0]}] // 质检报告
              this.reportImg = reportArr[0]// 质检报告

              this.qualityListSec= [{url:reportArr[1]}] // 企业荣誉第一张照片
              this.reportImgSec = reportArr[1]// 企业荣誉第一张照片

              this.qualityListFir= [{url:reportArr[2]}] // 企业荣誉第一张照片
              this.reportImgThr = reportArr[2]// 企业荣誉第一张照片
            }
          }

          var meritArr = res.merit
          if(meritArr != null){
            if(meritArr.length==1){
              this.awardsList= [{url:meritArr[0]}] // 企业获奖第一张照片
              this.awardsImg = meritArr[0]//企业获奖第一张照片

            } else if (meritArr.length==2){
              this.awardsList= [{url:meritArr[0]}] // 企业获奖第一张照片
              this.awardsImg = meritArr[0]//企业获奖第一张照片

              this.awardsListSec= [{url:meritArr[1]}] // 企业获奖第一张照片
              this.awardsImgSec = meritArr[1]//企业获奖第一张照片

            }else if (meritArr.length==3){
              this.awardsList= [{url:meritArr[0]}] // 企业获奖第一张照片
              this.awardsImg = meritArr[0]//企业获奖第一张照片

              this.awardsListSec= [{url:meritArr[1]}] // 企业获奖第一张照片
              this.awardsImgSec = meritArr[1]//企业获奖第一张照片

              this.awardsListFir= [{url:meritArr[2]}] // 企业荣誉第一张照片
              this.awardsImgThr = meritArr[2]// 企业荣誉第一张照片
            }
          }


          this.site= res.site
          this.wehcat= res.wechat
          this.weibo= res.weibo
          this.shop= res.shop
          this.wechat_video= res.wechat_video
          this.property = res.property
          this.shop_inside= res.shop_inside
          this.shop_outside =res.shop_outside
          this.company_vr = res.company_vr
          this.product_vr = res.product_vr
          this.motto= res.motto
          this.brandDes= res.brand
          this.founder_story= res.founder_story
          this.makings =res.makings
          this.exportRegion= res.export
          this.people_outside= res.people_outside
          this.people_inside= res.people_inside
          this.telephone=res.telephone
          this.people= res.people
          this.propagate= res.propagate
          this.buyer= res.buyer
          this.handle_things= res.handle_things
        }
      })
    },
    onConfirmBusiness(value) {
      this.valueBusiness = value;
      this.showPicker = false;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      console.log(this.fieldValue)
    },
    chooseSwitchover(){},
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过 5000kb');
    },
    beforeRead (file) {	//上传之前校验
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$toast('只允许上传jpg/png格式的图片！')
        return false
      }
      return true
    },
    async afterReadMajor(file){ // 核心产品1
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.majorImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadMajorSec(file){ // 核心产品2
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.majorImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadMajorFir(file){ // 核心产品3
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.majorImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadBrand(file){ // 企业商标
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.brandImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadBrandSec(file){ // 企业商标2
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.brandImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadBrandFir(file){ // 企业商标3
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.brandImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadQuality(file){ // 企业资质
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.qualityImg = res.data.source_url
      } else {
        this.$toast(message)
      }

    },
    async afterReadQualitySec(file){ // 企业资质
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.qualityImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadQualityFir(file){ // 三个上传照片
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.qualityImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadReport(file){ // 产品质检报告
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.reportImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadReportSec(file){ // 产品质检报告
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.reportImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadReportFir(file){ // 产品质检报告
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.reportImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadHonour(file){ // 上传企业荣誉
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.honourImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadHonourSec(file){
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.honourImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadHonourFir(file){ // 第三个上传照片
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.honourImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAwards(file){ // 上传企业获奖
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.awardsImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAwardsSec(file){// 上传企业获奖
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.awardsImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAwardsFir(file){// 上传企业获奖3
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.awardsImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAuth(file){ // 企业认证
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.authImg = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAuthSec(file){ // 企业认证2
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.authImgSec = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadAuthFir(file){ // 企业认证3
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.authImgThr = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterReadLicense(file){ // 上传营业执照
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      console.log(res)
      if (res.code==200){
        var licenseImg = res.data.source_url
        console.log(licenseImg)
        this.licenseImg = licenseImg
      }
    },
    async upLoaderImg(file) { //文件读取完成后的回调函数
      console.log(file);
      console.log(file.file);
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      console.log(res)
      if (res.code==200){
        // this.quality = res.data.url
      }
    },
    onConfirm(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      this.showArea = false;
    },
    async onSubmit(){// 提交信息
      // console.log('eeeeee')
      var ceoObj = {
        name:this.ceo,
        sex:this.sex_ceo
      }
      console.log(ceoObj)
      var founderObj = { // 创始人
        name:this.founder,
        sex: this.sex_founder
      }
      console.log(founderObj)
      var img_major = []
      if (this.majorImg != ''){  // majorImg:'',// 核心产品第一张照片
        img_major.push(this.majorImg)
      }
      if (this.majorImgSec != ''){ //   majorImgSec:'',// 核心产品第2张照片
        img_major.push(this.majorImgSec)
      }
      if (this.majorImgThr != ''){  //   majorImgThr:'',// 核心产品第3张照片
        img_major.push(this.majorImgThr)
      }

      var product = { // 	核心产品描述
        desc: this.productDes,
        image:img_major
      }
      console.log(product)
      var trademark = [] // 商标
      if (this.brandImg != ''){   // brandImg:'',// 企业商标第一张照片
        trademark.push(this.brandImg)
      }
      if (this.brandImgSec != ''){  //   brandImgSec:'',// 企业商标第2张照片
        trademark.push(this.brandImgSec)
      }
      if (this.brandImgThr != ''){ //   brandImgThr:'',// 企业商标第3张照片
        trademark.push(this.brandImgThr)
      }
      console.log(trademark)
      var qualityArr = [] // 企业资质
      if (this.qualityImg != ''){ // qualityImg:'',// 企业资质第一张照片
        qualityArr.push(this.qualityImg)
      }
      if (this.qualityImgSec != ''){  //   qualityImgSec:'',// 企业资质第2张照片
        qualityArr.push(this.qualityImgSec)
      }
      if (this.qualityImgThr != ''){ //   qualityImgThr:'',// 企业资质第3张照片
        qualityArr.push(this.qualityImgThr)
      }
      var reportImgArr = [] // 产品质检报告
      if (this.reportImg != ''){  // reportImg:'',//质检报告
        reportImgArr.push(this.reportImg)
      }
      if (this.reportImgSec != ''){ //   reportImgSec:'',//质检报告
        reportImgArr.push(this.reportImgSec)
      }
      if (this.reportImgThr != ''){ //   reportImgThr:'',//质检报告
        reportImgArr.push(this.reportImgThr)
      }
      // authImg:'',// 企业认证第一张照片
      //   authImgSec:'',// 企业认证第2张照片
      //   authImgThr:'',// 企业认证第2张照片
      var authImgArr = []
      if (this.authImg != ''){
        authImgArr.push(this.authImg)
      }
      if (this.authImgSec != ''){
        authImgArr.push(this.authImgSec)
      }
      if (this.authImgThr != ''){
        authImgArr.push(this.authImgThr)
      }
      var honourArr = []
      // honourImg:'',// 企业荣誉第一张照片
      //   honourImgSec:'',// 企业荣誉第2张照片
      //   honourImgThr:'',// 企业荣誉第2张照片
      if (this.honourImg != ''){
        honourArr.push(this.honourImg)
      }
      if (this.honourImgSec != ''){
        honourArr.push(this.honourImgSec)
      }
      if (this.honourImgThr != ''){
        honourArr.push(this.honourImgThr)
      }
      var meritaArr = []
      // awardsImg:'',// 企业获奖第一张照片
      //   awardsImgSec:'',// 企业获奖2张照片
      //   awardsImgThr:'',// 企业获奖第2张照片
      if (this.awardsImg != ''){
        meritaArr.push(this.awardsImg)
      }
      if (this.awardsImgSec != ''){
        meritaArr.push(this.awardsImgSec)
      }
      if (this.awardsImgThr != ''){
        meritaArr.push(this.awardsImgThr)
      }

      console.log(meritaArr)
      var data = {
        code:this.codeNum,
        name: this.name,
        en_name: this.en_name,
        place: this.valueCity,
        address: this.address,
        ceo: this.ceo +' '+ this.sex_ceo,
        founder: this.founder +' '+ this.sex_founder,
        // major: this.major, // 所属行业
        number: this.valueBusiness, 	// 企业入编(行业) 卷号
        license: this.licenseImg,
        'product[desc]': this.productDes, // 核心产品描述
        'product[image]': img_major, // 核心产品描述
        trademark: trademark,// 	商标
        site:this.site,
        wechat:this.wehcat,
        weibo:this.weibo,
        shop:this.shop,
        wechat_video:this.wechat_video,
        sale:this.sale,
        quality: qualityArr ,// 资质证书图片
        product_report: reportImgArr, // 产品质检报告
        auth: authImgArr, //企业认证
        honour: honourArr, // 企业荣誉
        merit: meritaArr,
        property:this.property,
        shop_inside:this.shop_inside,
        shop_outside:this.shop_outside,
        company_vr:this.company_vr,
        product_vr:this.product_vr,
        motto:this.motto,
        brand:this.brandDes,
        founder_story:this.founder_story,
        makings: this.makings,
        export:this.exportRegion,
        people_outside:this.people_outside,
        people_inside: this.people_inside,
        telephone:this.telephone,
        people:this.people,
        propagate:this.propagate,
        buyer:this.buyer,
        handle_things:this.handle_things
      }
      console.log(data)
      if(this.infoData != ''){ // b编辑
        companyEdit(this.infoData.id,data).then(res => {
          if(res.code == 200)
          {
            // this.$toast(res.message)
            // console.log('res',res.data)
            Dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.getDesReport()
            });

          }
          else
          {
            this.$toast(res.message)
          }
        })
      } else { // 第一次提交
        companyReportPost(data).then(res => {
          if(res.code == 200)
          {
            // this.$toast(res.message)
            // console.log('res',res.data)
            Dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.getDesReport()
            });

          }
          else
          {
            this.$toast(res.message)
          }
        })
      }


    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-uploader__upload{
  width: 2.13333rem!important;
  height: 2.13333rem!important;
}
/deep/.van-field__label {color: #282828}
.zicon-img-box{
  //background: #ffffff;
  .zicon-img{
    width: 100%;height: auto;display: block;margin: 0 auto;
  }
}
.intellectual-box /deep/.van-field--min-height .van-field__control {
  min-height: 2.4rem;
}
.hint-license{
  padding-left:255px;text-align: left;border-bottom: 1.5px solid #ebedf0;padding-bottom: 15px;color: #282828;font-size: .31rem;
}
.hint-license-box{
  padding: 0 30px 0; margin-top: -10px;background: #ffffff;position: relative;
  //color: #ee0a24;
}
.major-box{
  padding: 20px 30px 0;background: #ffffff;position: relative;
  .major-box-uploader{

  }
}
.brand-box{
  padding: 20px 30px 10px;background: #ffffff;position: relative;text-align: left;
  .title-name{
    width: 252px;text-align: left;
    color: #282828;
  }
}
.hint-box{
  padding: 30px 30px 0;font-size: 26px;color: #282828;text-align: left;line-height: 60px;
}
.item-box{
  padding: 10px 30px 0;text-align: left;font-size: 26px;color: #333333;line-height:50px;
}
/deep/.van-field__label {
  width: 230px;
}
/deep/.van-uploader__upload {
  width: 1.75rem;height: 1.75rem;
}
.title{
  font-size: 32px;text-align: center;padding: 20px 0;font-weight: bold;
}
.van-field-box{
  background: #ffffff;position: relative;
  //border-bottom: 1px solid #ebedf0;
  .van-radio-group--horizontal{
    margin-left: 10px;
  }
  /deep/ .van-radio__label {
    margin-left: 5px;
  }
  /deep/ .van-radio--horizontal {
    margin-right: 12px;
  }
}
.van-field-box::after{
  content: '';
  width: 92%;height: 1px;background: #ebedf0; left: 3%;bottom: 2px;position: absolute;
}
</style>
